import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { first, Subject } from 'rxjs';
import { GungModalService } from '../../../services/gung-modal/gung-modal.service';
import { NavbarCartModel, NavbarCartService } from '../../../services/navbar-cart/navbar-cart.service';
import { ProductInputQuantityConfigService } from '../../../services/product-input-quantity-config/product-input-quantity-config.service';
import { SaveCartModalConfigService } from '../../../services/save-cart-modal-config/save-cart-modal-config.service';
import { GungEventSystemService } from '../../../services/gung-event-system/gung-event-system.service';
import { CustomerService } from '../../../services/customers/customer.service';

@Component({
  selector: 'lib-gung-navbar-cart',
  templateUrl: './gung-navbar-cart.component.html',
  styleUrl: './gung-navbar-cart.component.scss',
  standalone: false
})
export class GungNavbarCartComponent implements OnInit {
  protected gungModalService = inject(GungModalService);
  protected navbarCartService = inject(NavbarCartService);
  protected saveCartModalConfigService = inject(SaveCartModalConfigService);
  protected productInputQuantityConfigService = inject(ProductInputQuantityConfigService);
  protected gungEventSystemService = inject(GungEventSystemService);
  protected customerService = inject(CustomerService)

  cartContentsSubject = new Subject<NavbarCartModel>();
  cartContents: NavbarCartModel;

  @Output() close = new EventEmitter<void>();
  numberOfCustomers = 0;
  

  ngOnInit(): void {
    this.cartContentsSubject.subscribe(contents => {
      this.cartContents = contents;
    })
    this.customerService.getCustomerCount().pipe(first()).subscribe(count =>{
      this.numberOfCustomers = count;
    })
  }

  clearCart() {
    this.gungModalService.openConfirmYesNoModal(undefined, 'CLEAR_CART_CONFIRM', { size: 'sm' }).then(
      result => {
        if (result) {
          this.navbarCartService.clearCart();
          this.gungEventSystemService.emitGungEvent('clearCart', {});
        }
      },
      reason => { }
    );
  }

  saveCart(): void {
    this.saveCartModalConfigService.openSaveCartModal();
  }

  onClose(): void {
    this.close.emit();
  }
}
